import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { resolveDeposit } from '../../lib/deposit';

export const DetailsStep = ({
  service,
  barber,
  slot,
  customerData,
  setCustomerData,
  submitting,
  shop,
  onBack,
  onSubmit,
}) => {
  const dep = service ? resolveDeposit(service, shop || {}) : { required: false, amount: 0 };
  return (
    <div className="booking-step">
      <button className="back-btn" onClick={onBack}>
        <ArrowLeft size={16} /> Back
      </button>
      <h2>Your details</h2>
      <div className="booking-summary">
        <p><strong>{service?.name}</strong> · {service?.duration_min} min · £{service?.price.toFixed(2)}</p>
        <p>
          {barber?.name} · {slot?.datetime
            ? slot.datetime.toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long' })
            : 'Selected day'} at {slot?.display}
        </p>
      </div>
      <form onSubmit={onSubmit}>
        <div className="field">
          <label>Name</label>
          <input
            className="inp"
            type="text"
            value={customerData.name}
            onChange={(e) => setCustomerData({ ...customerData, name: e.target.value })}
            required
            placeholder="Your name"
          />
        </div>
        <div className="field">
          <label>Phone</label>
          <input
            className="inp"
            type="tel"
            value={customerData.phone}
            onChange={(e) => setCustomerData({ ...customerData, phone: e.target.value })}
            required
            placeholder="07700 900000"
          />
        </div>
        <div className="field">
          <label>Email</label>
          <input
            className="inp"
            type="email"
            value={customerData.email}
            onChange={(e) => setCustomerData({ ...customerData, email: e.target.value })}
            required
            placeholder="you@example.com"
          />
        </div>
        <button type="submit" className="btn-confirm" disabled={submitting}>
          {submitting
            ? 'Processing...'
            : (dep.required
                ? `Continue to Payment (£${dep.amount} deposit)`
                : 'Confirm Booking')}
        </button>
      </form>
    </div>
  );
};
